export var MODAL_TYPE;
(function (MODAL_TYPE) {
    MODAL_TYPE["AUTO"] = "AUTO";
    MODAL_TYPE["OK"] = "OK";
    MODAL_TYPE["YESNO"] = "YESNO";
    MODAL_TYPE["CLOSE"] = "CLOSE";
})(MODAL_TYPE || (MODAL_TYPE = {}));
export class ModalService {
    constructor() {
        this.on = new ModalEventContainer(this, MODAL_TYPE.AUTO);
        this.queue = [];
    }
    /**
    * Checks if the modal dialog is being displayed
    * @returns {boolean} true if its visible, false if its invisible
    */
    isVisible() {
        const modal = document.querySelector('.modal');
        if (modal == null) {
            console.error('NO MODAL FOUND!');
        }
        return (modal === null || modal === void 0 ? void 0 : modal.classList.contains('hidden')) !== true;
    }
    /**
    * Get next modal in queue
    * @returns {{title: string, html: any, on: ModalEventContainer, displayOnce: boolean}} next modal in the queue
    */
    getNextInQueue() {
        return this.queue.shift();
    }
    msg(msg) {
        return modalService.create({
            title: '',
            content: msg
        });
    }
    /**
    * Create popup modal dialog
    */
    create(options) {
        const defaultOptions = {
            type: MODAL_TYPE.AUTO,
            displayOnce: false
        };
        const { title, content, type, displayOnce } = Object.assign({}, defaultOptions, options);
        const html = (content instanceof jQuery) ? content : this.formatMessage(content).trim();
        const on = new ModalEventContainer(this, type);
        this.queue.push({ title, html, on, displayOnce });
        on.clearEvents();
        on.onClose(_ => {
            this.hide();
            this.tryShowNext(html);
        });
        const isVisible = this.isVisible();
        return (!isVisible) ? this.viewModal(this.getNextInQueue()) : on;
    }
    /**
    * Check queue and display next popup dialog
    * @param {string} prevHtml
    */
    tryShowNext(prevHtml) {
        if (this.queue.length > 0) {
            const nextInQueue = this.getNextInQueue();
            if (nextInQueue.displayOnce) {
                if (prevHtml !== nextInQueue.html) {
                    this.viewModal(nextInQueue);
                }
                this.tryShowNext(prevHtml);
            }
            else {
                this.viewModal(nextInQueue);
            }
        }
    }
    /**
    * Gets the button containers
    * @returns UI button containers
    */
    getElements() {
        return {
            modalYesNo: document.querySelector('.modal-yesno'),
            modalOk: document.querySelector('.modal-ok'),
            modalClose: document.querySelector('.modal-close'),
        };
    }
    /**
    * Gets the event container
    * @returns {ModalEventContainer}
    */
    getEvents() {
        return this.on;
    }
    /**
    * Update modal buttons to correct options
    * @param {MODAL_TYPE} modalType
    */
    updateOptions(modalType) {
        const { modalYesNo, modalOk, modalClose } = this.getElements();
        // Decide which buttons to show
        switch (modalType) {
            case MODAL_TYPE.OK:
                modalOk.classList.remove('hidden');
                modalYesNo.classList.add('hidden');
                modalClose.classList.add('hidden');
                break;
            case MODAL_TYPE.YESNO:
                modalOk.classList.add('hidden');
                modalYesNo.classList.remove('hidden');
                modalClose.classList.add('hidden');
                break;
            case MODAL_TYPE.CLOSE:
                modalOk.classList.add('hidden');
                modalYesNo.classList.add('hidden');
                modalClose.classList.remove('hidden');
                break;
            default:
                modalOk.classList.add('hidden');
                modalYesNo.classList.add('hidden');
                modalClose.classList.remove('hidden');
                break;
        }
    }
    /**
    * Show popup window
    */
    viewModal({ title, html, on }) {
        this.on = on;
        this.updateOptions(on.modalType);
        const eleModal = document.querySelector('.modal');
        const eleTitle = document.querySelector('.modal .modal-header .modal-title');
        const eleContent = document.querySelector('.modal .modal-body .content');
        eleTitle.innerHTML = title || '';
        if (html instanceof jQuery) {
            const $content = $(eleContent);
            $content.html('');
            $content.append(html);
        }
        else {
            eleContent.innerHTML = html;
        }
        eleModal.classList.remove('hidden');
        return on;
    }
    /**
    * Hide popup window
    */
    hide() {
        var _a;
        (_a = document.querySelector('.modal')) === null || _a === void 0 ? void 0 : _a.classList.add('hidden');
    }
    /**
    * Display error popup message
    * @param text optional override error message
    * @param modalType type of dialog
    */
    error(text, modalType = MODAL_TYPE.OK) {
        return this.create({
            title: 'Error',
            content: ((text instanceof Error) ? null : text) || 'Er is iets fout gegaan!<br>Probeer het later opnieuw.',
            type: modalType,
            displayOnce: true
        }); //.onClose(_ => this.loadingService.reset())
    }
    /**
    * Add newlines to show properly formatted html
    * @param textInput html or text message to display
    * @returns {string} formatted html message
    */
    formatMessage(textInput) {
        return (typeof textInput === 'string' ? textInput : '').replace('\r\n', '<br>');
    }
    /**
    * Display all possible pre-configured messages
    */
    // showAllPreconfiguredMessages() {
    // 	Object.values(MESSAGES).map(message => {
    // 		this.create(message).onClose(_ => {})
    // 	})
    // }
    notImplementedYet() {
        return this.create({
            title: 'Whoops!',
            content: 'Not Implemented Yet!',
            type: MODAL_TYPE.YESNO
        });
    }
}
export class ModalEventContainer {
    constructor(modal, modalType) {
        this.modal = modal;
        this.modalType = modalType;
        this.proceedEvents = [];
        this.cancelEvents = [];
        this.closeEvents = [];
    }
    get $() {
        return $('.modal');
    }
    get generatedModalType() {
        const { modalType, proceedEvents, cancelEvents } = this;
        if (modalType === MODAL_TYPE.AUTO) {
            return (proceedEvents.length > 0 && cancelEvents.length > 0) ? MODAL_TYPE.YESNO : MODAL_TYPE.OK;
        }
        return modalType;
    }
    // BEGIN EVENT CALLS
    callProceed() {
        return Promise.all(this.proceedEvents.concat(this.closeEvents).map(cb => cb()));
    }
    callCancel() {
        return Promise.all(this.cancelEvents.concat(this.closeEvents).map(cb => cb()));
    }
    callClose() {
        return Promise.all(this.closeEvents.map(cb => cb()));
    }
    // END EVENT CALLS
    // BEGIN REGISTER MODAL EVENTS
    onProceed(cb) {
        this.proceedEvents.push(cb);
        this.modal.updateOptions(this.generatedModalType);
        return this;
    }
    onCancel(cb) {
        this.cancelEvents.push(cb);
        this.modal.updateOptions(this.generatedModalType);
        return this;
    }
    onClose(cb) {
        this.closeEvents.push(cb);
        return this;
    }
    // END REGISTER MODAL EVENTS
    clearEvents() {
        this.proceedEvents = [];
        this.cancelEvents = [];
        this.closeEvents = [];
    }
}
//# sourceMappingURL=modal_service.js.map